var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkerAssigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6079 12C13.6455 12 16.1079 9.53757 16.1079 6.5C16.1079 3.46243 13.6455 1 10.6079 1C7.57034 1 5.10791 3.46243 5.10791 6.5C5.10791 9.53757 7.57034 12 10.6079 12Z",
    stroke: "#34AD00",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1079 23H3.20048C2.8885 23.0001 2.58007 22.9338 2.29567 22.8056C2.01127 22.6773 1.75739 22.49 1.55089 22.2562C1.34439 22.0223 1.19 21.7472 1.09794 21.4491C1.00589 21.151 0.978294 20.8368 1.01698 20.5272L1.44598 17.0908C1.54575 16.2925 1.93374 15.5581 2.53699 15.0257C3.14025 14.4933 3.91721 14.1997 4.72178 14.2H5.10788",
    stroke: "#34AD00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0078 16.4L17.4828 18.6L21.6078 14.2",
    stroke: "#34AD00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerAssigned);
export default __webpack_public_path__ + "static/media/workerAssigned.bf84daaa87671fdf51ace13216290211.svg";
export { ForwardRef as ReactComponent };